export { Footer as default } from './Footer';
export { Content } from './Footer.views';